import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};
export type BookingList = {
  planName: string;
  planAmount: number;
  planDuration: number;
  mileageLimit: number;
  allowedLocations: string;
  vehicleCategory: string;
  paymentMethod: number;
  additionalBenefits: string;
};

export const subscriptionApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getBookings: builder.query<
      CommonResponse & { data: any },
      { page: number; search: string }
    >({
      query: ({ page, search }) => ({
        url: `${END_POINTS.getBookings}?page=${page}&searchText=${search}`,
        method: "GET",
      }),
    }),

    getBookingsById: builder.query<
      CommonResponse & { data: any },
      { id: string | undefined }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getBookings}/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useLazyGetBookingsQuery, useLazyGetBookingsByIdQuery } =
  subscriptionApi;
